/**
 * SB CT-LP v4 — direct checkout, discount auto-apply, countdown, sticky ATC
 */
(function(){'use strict';
function fillCells(el,str){if(!el)return;el.innerHTML='';for(var i=0;i<str.length;i++){var c=document.createElement('div');c.className='sb-lp-cd__cell';c.textContent=str.charAt(i);el.appendChild(c)}}

function initCountdown(root){
  var defaultSec=parseInt(root.dataset.cdDefault,10)||52791;
  var key='sb_lp_cd_end';
  var stored=sessionStorage.getItem(key);
  var endMs=stored?parseInt(stored,10):null;
  if(!endMs||endMs<=Date.now()){
    endMs=Date.now()+defaultSec*1000;
    sessionStorage.setItem(key,String(endMs));
  }
  var elH=root.querySelector('[data-cd="hours"]'),elM=root.querySelector('[data-cd="minutes"]'),elS=root.querySelector('[data-cd="seconds"]');
  if(!elH||!elM||!elS)return;
  function tick(){
    var diff=endMs-Date.now();
    if(diff<=0){endMs=Date.now()+defaultSec*1000;sessionStorage.setItem(key,String(endMs));diff=endMs-Date.now()}
    var sec=Math.floor(diff/1000),h=Math.floor(sec/3600),m=Math.floor((sec%3600)/60),s=sec%60;
    fillCells(elH,String(h).padStart(2,'0'));
    fillCells(elM,String(m).padStart(2,'0'));
    fillCells(elS,String(s).padStart(2,'0'));
  }
  tick();setInterval(tick,1000);
}

function initStickyManager(){
  var pairs=[];
  document.querySelectorAll('[data-sb-sticky]').forEach(function(el){
    var id=el.dataset.sbSticky;
    var sentinel=document.querySelector('[data-sb-sticky-sentinel="'+id+'"]');
    if(!sentinel)return;
    pairs.push({el:el,sentinel:sentinel});
  });
  if(!pairs.length)return;
  // While the on-page buybox (Kaching) or checkout area is in the viewport,
  // the sticky CTA is suppressed — it would only distract there.
  function stickySuppressed(){
    var els=document.querySelectorAll('.kaching-bundles, [data-sb-sticky-suppress]');
    for(var s=0;s<els.length;s++){
      var r=els[s].getBoundingClientRect();
      if(r.height>0&&r.top<window.innerHeight&&r.bottom>0)return true;
    }
    return false;
  }
  function update(){
    var scrolled=window.pageYOffset>80;
    var active=-1;
    if(scrolled&&!stickySuppressed()){
      var bestTop=-Infinity;
      for(var i=0;i<pairs.length;i++){
        var top=pairs[i].sentinel.getBoundingClientRect().top;
        if(top<=0&&top>bestTop){
          bestTop=top;
          active=i;
        }
      }
      if(active===-1)active=0;
    }
    for(var j=0;j<pairs.length;j++){
      if(j===active){
        pairs[j].el.classList.add('is-visible');
      }else{
        pairs[j].el.classList.remove('is-visible');
      }
      pairs[j].el.style.display='';
    }
    if(active!==-1){
      document.body.classList.add('sb-lp-sticky-on');
    }else{
      document.body.classList.remove('sb-lp-sticky-on');
    }
  }
  update();
  window.addEventListener('scroll',update,{passive:true});
  window.addEventListener('resize',update);
}

function syncForms(gid){var forms=document.querySelectorAll('form[data-sb-form="'+gid+'"]');if(forms.length<2)return;function sync(){var m=forms[0].querySelector('[name="id"]');if(!m)return;forms.forEach(function(f){var t=f.querySelector('[name="id"]');if(t&&t!==m)t.value=m.value})}forms.forEach(function(f){f.addEventListener('change',sync)});sync()}

window.onSubmitAtcForm=function(form,e){
  e.preventDefault();
  var btn=form.querySelector('[type="submit"]');
  btn.disabled=true;
  btn.innerHTML='<span style="opacity:.7">…</span>';
  var variantId=form.querySelector('[name="id"]').value;
  var discountEl=document.querySelector('[data-sb-discount]');
  var code=discountEl?discountEl.dataset.sbDiscount:'';
  var redirectEl=document.querySelector('[data-sb-cart-redirect]');
  var dest=redirectEl&&redirectEl.dataset.sbCartRedirect?redirectEl.dataset.sbCartRedirect:'/checkout';
  fetch('/cart/add.js',{
    method:'POST',
    headers:{'Content-Type':'application/x-www-form-urlencoded'},
    body:'id='+variantId+'&quantity=1'
  }).then(function(){
    if(code){
      window.location.href='/discount/'+encodeURIComponent(code)+'?redirect='+encodeURIComponent(dest);
    }else{
      window.location.href=dest;
    }
  }).catch(function(){btn.innerHTML='Fehler';btn.disabled=false;});
};

function applyDiscount(){
  var el=document.querySelector('[data-sb-discount]');
  if(!el)return;
  var code=el.dataset.sbDiscount;
  if(!code)return;
  if(sessionStorage.getItem('sb_lp_discount_applied')===code)return;
  fetch('/discount/'+encodeURIComponent(code),{method:'GET',redirect:'manual'})
    .then(function(){sessionStorage.setItem('sb_lp_discount_applied',code);})
    .catch(function(){});
}

// CTA smooth scroll — buttons with [data-sb-scroll-btn] scroll to the target
// selector instead of submitting/redirecting (used to jump to the on-page buybox).
document.addEventListener('click',function(e){
  var btn=e.target.closest('[data-sb-scroll-btn]');
  if(!btn)return;
  e.preventDefault();
  var sel=btn.getAttribute('data-sb-scroll-btn');
  if(!sel)return;
  var target;
  try{target=document.querySelector(sel)}catch(err){return}
  if(!target)return;
  var offset=parseInt(btn.getAttribute('data-sb-scroll-offset')||'80',10);
  var top=target.getBoundingClientRect().top+window.pageYOffset-offset;
  if(top<0)top=0;
  var reduced=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  window.scrollTo({top:top,behavior:reduced?'auto':'smooth'});
});

document.addEventListener('DOMContentLoaded',function(){
  document.querySelectorAll('[data-sb-countdown]').forEach(initCountdown);
  initStickyManager();
  document.querySelectorAll('[data-sb-sync]').forEach(function(el){syncForms(el.dataset.sbSync)});
  applyDiscount();
});
})();
